// extracted by mini-css-extract-plugin
module.exports = {"uploadedDocCard":"UploadedDocument_uploadedDocCard__1FJir","left":"UploadedDocument_left__2S4Eo","right":"UploadedDocument_right__2YKoS"};